import React from 'react'
import { CustomSelect } from '../../Components/CustomSelect';
import { ButtonElement } from '../../FormElements/ButtonElement';
import { RouteHeader } from '../../Components/RouteHeader';
import { AsterikLabel } from '../../Components/AsterikLabel';
import { TextInput } from '../../FormElements/TextInput';
import { createProjectPayload, generateQuestionSetBasedOnProject, getModifyProjectDataPayload, selectHRISOptionList, submitToUpload } from './helper';
import ModalWindow from '../../Components/CsvUploadModal';
import { deepCopy } from '../../utils/deepCopy';
import { encryptJson, getDataFromUrlToken } from '../../utils/urlDataStore';
import { URL_DATA } from '../../../config/urlDataConstants';
import { COHORT_SURVEY_SECTION, SURVEY_WIZARD_TABS } from '../../../config/tabConstants';
import { getFetchHRISPayload } from './helper'
import { APPLIED_ORG_IDS_PROD, ARCTERYX_ORGS, FEEDBACK_360_FOR_PARTICULAR_ORG_IDS, FEEDBACK_360_SURVEY, MASCO_ORG_IDS_PROD } from '../../../config/questionTypeConstants';
import { Spin } from 'antd';
import constants, { HRIS_TYPE_OPTIONS } from './constants'
import Container from '../../Components/Container';
import { Row } from 'react-bootstrap';
import "./index.scss";
import { LoaderButton } from '../../FormElements/LoaderButton';
import { toast } from '../../utils/messageUtils';
import { getNewSurveyPagePath } from '../../utils/getHomePath';
import { nlpSetURLParams } from '../../utils/nlpURLUtils';
import { SelectElement } from '../../FormElements/SelectElement';
class CohortSuvey extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showHRISUploadModal: false,
            setUpSelectData: '1',
            showWarningModal: false,
            showAddInviteesModal: false,
            inputValue: "",
            disableButton: "",
            selectedOption: null,
            loadingState: false,
            childProjectType: this.getOptionsList()[0].value
        }
    }

    componentDidMount() {
        let fetchHRISPayload = getFetchHRISPayload();
        this.props.surveyWizardFetchHRISFiles({ ...fetchHRISPayload });
    }

    handleChange = (value) => {
        this.setState({
            inputValue: value.value
        })
    }
    closeHRISUploadModal = (cb) => {
        this.setState({
            ...this.state,
            showHRISUploadModal: false
        })
        this.props.handleFileUpload(null)
        cb('')
    }

    showHRISUploadModal = () => {
        this.setState({
            ...this.state,
            showHRISUploadModal: true
        })
    }

    getCSVUploadModal = () => {
        return (
            <ModalWindow
                {...this.props}
                hrisFileTypeSelections={HRIS_TYPE_OPTIONS}
                handleModalState={(cb) => this.closeHRISUploadModal(cb)}
                isBulkAddModalVisible={this.state.showHRISUploadModal}
                submitToUpload={(cb, fileName) => submitToUpload(cb, fileName, this)}
                handlechange={this.handleCheckChange}
                fileToUpload={this.props.fileToUpload}
            />
        )
    }

    hrisSelectChange = (selectedOption) => {
        this.setState({ selectedOption });

    };

    onUploadClick = (fileName, fileId) => {
        this.props.surveyWizardFetchHRISFiles({ ...getFetchHRISPayload() });
        this.setState({ selectedOption: fileId });
        this.props.fileUploadStatus({ hrisFileId: fileId, currentTab: COHORT_SURVEY_SECTION.CREATE_COHORT_SURVEY }, (response) => {
            this.recallFileUploadStatusApi({ hrisFileId: fileId, currentTab: COHORT_SURVEY_SECTION.CREATE_COHORT_SURVEY }, response);
        });

    }

    recallFileUploadStatusApi = (fileUploadData, response) => {
        if (response && response.data.data.response.hrisFilesStatus.bulkJobStatus === constants.QUEUED) {
            this.setState({ disableButton: true })
            this.props.fileUploadStatus(fileUploadData, (response) => {
                setTimeout(() => {
                    this.recallFileUploadStatusApi(fileUploadData, response);
                }, 3000);
            })
        }
        else {
            this.setState({ disableButton: false })
            let fetchHRISPayload = getFetchHRISPayload();
            this.props.surveyWizardFetchHRISFiles({ ...fetchHRISPayload });
            this.setState({ selectedOption: fileUploadData.hrisFileId });
        }
    }

    getHRISselectElement = () => {
        return (
            <Spin spinning={this.props.surveyWizardHrisFIleApi.isProcessing}>
                <CustomSelect
                    disabled={this.state.disableButton}
                    disableSearch={true}
                    value={this.state.selectedOption}
                    placeholder={"Select HRIS"}
                    optionList={selectHRISOptionList({ hrisData: this.props.surveyWizardHrisFIleApi.data, hrisFilesStatus: this.props.HRISUploadStatus.data ? this.props.HRISUploadStatus.data.hrisFilesStatus : {}, isFromCohort: true })}
                    className="participants-select"
                    onChange={this.hrisSelectChange}
                />
            </Spin>
        );
    }

    routeToProjectsPage = () => {
        const orgDetails = getDataFromUrlToken(URL_DATA.ORGANIZATION);
        const org_id = orgDetails.organizationId
        const encryptedOrgDetails = encryptJson({ orgDetails });
        this.props.history.push({
            pathname: `/home/${org_id}/surveys/cohortTab`,
            search: nlpSetURLParams({ params: encryptedOrgDetails }),
        });

    }
    createCohortProject = () => {
        this.setState({ loadingState: true });
        let payload = createProjectPayload(this)
        this.props.NewProjectPageCreateProject(
            { ...payload },
            (success, response) => {
                this.callBack(success, response)
            }
        )
    }

    callBack = (success, response) => {
        if (success) {
            toast.success(constants.PROJECT_CREATE_MESSAGE)
            const orgDetails = getDataFromUrlToken(URL_DATA.ORGANIZATION);
            const orgId = orgDetails.organizationId
            let questionSet = generateQuestionSetBasedOnProject({ ...this.props, projectType: this.state.childProjectType })
            let updatedDoc = {
                questionSet: questionSet, aboutSurvey: constants.ABOUT_SURVEY_PLACEHOLDER(this.state.childProjectType),
                questionSetUpdatedDate: new Date().toISOString(),
                endMessage: constants.END_MESSAGE_PLACEHOLDER(this.state.childProjectType),
                childProjectType: this.state.childProjectType,
                //masco
                //logoUrl: "https://s3.amazonaws.com/culturebie-uploadbucket/79616763-5a85-4df2-980e-6bcbf88cbc51_f0sikgu2mhe2h1ga_masco.png"
                //applied logo
                //https://culturebiedev-uploadimages.s3.us-east-1.amazonaws.com/APPLIED_Impact_Logo_blue_28%3A11%3A2025.png
            }
            if (MASCO_ORG_IDS_PROD.includes(orgId)) {
                updatedDoc.logoUrl = "https://s3.amazonaws.com/culturebie-uploadbucket/79616763-5a85-4df2-980e-6bcbf88cbc51_f0sikgu2mhe2h1ga_masco.png"
            }
            if (APPLIED_ORG_IDS_PROD.includes(orgId)) {
                updatedDoc.logoUrl = "https://culturebiedev-uploadimages.s3.us-east-1.amazonaws.com/APPLIED_Impact_Logo_blue-02-12-2025.png"

            }


            if (this.state.childProjectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX) {
                updatedDoc["aboutSurvey#/self"] = constants.ABOUT_SURVEY_SELF_ARCTERYX
            }
            let payload = getModifyProjectDataPayload(updatedDoc, deepCopy(response))
            this.props.surveyWizardModifyProjectData({ ...payload }, (sucess) => {
                if (sucess) {
                    this.setState({ loadingState: false })
                    this.routeToProjectsPage()
                } else {
                    this.setState({ loadingState: false })
                    toast.error(constants.ERROR_TOAST_MODIFY_PROJECT)
                }

            })

        }
        else {
            this.setState({ loadingState: false })
            toast.error(constants.ERROR_TOAST_CREATE_PROJECT)
        }
    }

    checkIfButtonDisabled = () => {
        if (!this.state.inputValue.trim().length > 0 || !this.state.selectedOption || this.state.disableButton) {
            return true
        }
        else {
            return false
        }
    }

    handleChangeProjectType = (value, event) => {
        this.setState({
            childProjectType: value
        })

    }

    getOptionsList = () => {
        const orgDetails = getDataFromUrlToken(URL_DATA.ORGANIZATION);
        const orgId = orgDetails.organizationId
        if (orgId === "21bngf8lweq94eb") {
            return constants.PROJECT_TYPES_APPLIED
        }
        else if (orgId === "1078lprpgdex" || orgId === "jef68lt7dlaqg") {
            return constants.PROJECT_TYPES_MASCO
        }
        else if (ARCTERYX_ORGS.includes(orgId))
            return constants.PROJECT_TYPE_OPTIONS_ARCTERYX
        return constants.PROJECT_TYPE_OPTIONS
    }

    render() {
        return (
            <>
                <Spin spinning={this.state.loadingState} tip={constants.LOADING_SPINNER_TEXT}>
                    <Container>
                        <Row>

                            <RouteHeader
                                {...this.props}
                                navigationData={constants.navigationList}
                                title={"Cohort survey"}
                            />

                            <div className='CohortSuvey'>
                                <div className='col-lg-3 col-md-12 col-sm-12 col-xs-12'>
                                    <div className='CohortSuvey__Left'>
                                        {this.getCSVUploadModal()}

                                        <h4>Choose HRIS file to send </h4>

                                        <>
                                            {this.getHRISselectElement()}
                                            <ButtonElement
                                                disabled={this.state.disableButton}
                                                type='primary'
                                                onClick={this.showHRISUploadModal}
                                            >
                                                Upload new HRIS file
                                            </ButtonElement>
                                            <h4>
                                                Choose project type
                                            </h4>
                                            <SelectElement
                                                disabled={false}
                                                disableSearch={true}
                                                value={this.state.childProjectType}
                                                optionList={this.getOptionsList()}
                                                className="setup-select"
                                                onChange={this.handleChangeProjectType}
                                            />
                                            <h4>
                                                Enter project name <AsterikLabel />
                                            </h4>
                                            <TextInput
                                                placeholder="Enter project name"
                                                value={this.state.inputValue}
                                                handleChange={this.handleChange}
                                            />


                                            <LoaderButton
                                                onClick={this.createCohortProject}
                                                disabled={this.checkIfButtonDisabled()}
                                                classList={constants.loaderButton.classes}
                                                loaderClass={constants.loaderButton.loaderClass}
                                                text={constants.BUTTON_NAME}
                                            />
                                        </>
                                    </div>

                                </div>
                                {/* <div className='col-lg-9 col-md-12 col-sm-12 col-xs-12'>Cohort survey
</div> */}
                            </div>
                        </Row>
                    </Container>
                </Spin>
            </>
        )
    }
}
export default CohortSuvey;
